import { ThemeOptions } from '@material-ui/core';
import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    type: 'light',
    primary: {
      light: '#58dfca',
      main: '#00ad99',
      dark: '#007d6b',
      contrastText: '#FFFFFF',
    },
    secondary: {
      light: '#ffffff',
      main: '#ff6637',
      dark: '#c30000',
      contrastText: '#000000',
    },
  },
});
export interface CustomThemeOptions extends ThemeOptions {
  sidebar?: {
    width?: string;
  },
  menu?: {
    width?: string;
  };
}

const customTheme: CustomThemeOptions = {
  ...theme,
  sidebar: {
    width: 'fit-content',
  },
  menu: {
    width: 'fit-content'
  }
};

export default customTheme;
